import { ChangeDetectionStrategy, Component, input } from '@angular/core';

import { CurrencyComponent } from '@web/shared/ui';

@Component({
  selector: 'app-public-order-summary-additional-shipping-cost-info',
  imports: [CurrencyComponent],
  templateUrl:
    './public-order-summary-additional-shipping-cost-info.component.html',
  styleUrl:
    './public-order-summary-additional-shipping-cost-info.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PublicOrderSummaryAdditionalShippingCostInfoComponent {
  public readonly quantity = input.required<number>();
  public readonly unitPrice = input.required<number>();
}
